"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queries = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactMediaQueryHoc = require("react-media-query-hoc");
var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));
var _core = require("@emotion/core");
var _excluded = ["device"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var DeviceTypes = ['desktop', 'tv', 'tablet', 'phone', 'bot', 'car'];
var breakpoints = {
  mobileMinWidth: 0,
  mobileMaxWidth: 623,
  tabletMinWidth: 624,
  tabletMaxWidth: 1020,
  desktopMinWidth: 1021,
  desktopNewHeaderMinWidth: 1080,
  desktopMaxWidth: 1440,
  largeDesktopMinWidth: 1800,
  smallTabletMaxWidth: 920
};
var getWidthFromDevice = device => {
  switch (device) {
    case 'desktop':
    case 'bot':
      return breakpoints.desktopMaxWidth;
    case 'tablet':
      return breakpoints.tabletMaxWidth;
    default:
      return breakpoints.mobileMaxWidth;
  }
};
var queries = exports.queries = {
  mobile: "(max-width: ".concat(breakpoints.mobileMaxWidth, "px)"),
  tablet: "(min-width: ".concat(breakpoints.tabletMinWidth, "px) and (max-width: ").concat(breakpoints.tabletMaxWidth, "px)"),
  desktop: "(min-width: ".concat(breakpoints.desktopMinWidth, "px)"),
  desktopNewHeader: "(min-width: ".concat(breakpoints.desktopNewHeaderMinWidth, "px)"),
  smallTablet: "(min-width: ".concat(breakpoints.tabletMinWidth, "px) and (max-width: ").concat(breakpoints.smallTabletMaxWidth, "px)"),
  desktopExtraWide: "screen and (min-width: ".concat(breakpoints.largeDesktopMinWidth, "px)"),
  landscapeMobile: "(min-width: ".concat(breakpoints.tabletMinWidth, "px) and (max-height: ").concat(breakpoints.mobileMaxWidth, "px)")
};
var withMediaQueryProvider = WrappedComponent => {
  var Enhance = props => {
    var _props$device = props.device,
      device = _props$device === void 0 ? 'phone' : _props$device,
      otherProps = _objectWithoutProperties(props, _excluded);
    var values = {
      width: getWidthFromDevice(device)
    };
    return (0, _core.jsx)(_reactMediaQueryHoc.MediaQueryProvider, {
      queries: queries,
      values: values
    }, (0, _core.jsx)(WrappedComponent, otherProps));
  };
  Enhance.displayName = "MediaQueryProvider(".concat(WrappedComponent.displayName || WrappedComponent.name || 'Component', ")");
  return (0, _hoistNonReactStatics.default)(Enhance, WrappedComponent);
};
var _default = exports.default = withMediaQueryProvider;